import Excel from 'exceljs';

const readXLSXFromUrl = url => fetch(url)
  .then(response => response.arrayBuffer())
  .then(response => {
    const data = new Uint8Array(response);
    const array = data.reduce((result, chunk) => {
      result.push(String.fromCharCode(chunk));

      return result;
    }, []);
    return array.join('');
  })
  .then(async response => {
    const workbook = new Excel.Workbook();
    await workbook.xlsx.load(response);
    return workbook;
  });

export default readXLSXFromUrl;
